import api from "./api";

/**
 * Runtime translation of user-written text (recognitions, comments) via the
 * backend, which detects the source language, translates with Amazon
 * Translate and caches the result. Target defaults to the caller's locale.
 */
const translationService = {
  /** -> { text, source_lang, target_lang, cached } */
  translate: async (text, target) => {
    const response = await api.post("/api/v1/i18n/translate", {
      text,
      ...(target ? { target } : {}),
    });
    return response.data;
  },
};

export default translationService;
